import { Checkbox, FormControlLabel } from "@mui/material";
import { useTranslate } from "@/hooks";
import { colorPrimary, colorSecondary } from "@/constants/colors";
import { Hint } from "@/HOC";
import { TCustomCheckboxProps } from "./CustomCheckbox.props";

const CustomCheckbox = ({ label, hint = "", hintPosition, sxFormControlLabel, ...props }: TCustomCheckboxProps): JSX.Element => {
	const translate = useTranslate(); // hook для перевода текста

	return (
		<Hint hint={hint} position={hintPosition}>
			<FormControlLabel
				sx={{
					marginRight: "auto",
					".MuiTypography-root, .MuiFormControlLabel-asterisk": {
						color: colorPrimary,
						fontFamily: "inherit",
						fontSize: 13,
						fontStyle: "inherit",
						fontWeight: "inherit",
						lineHeight: "inherit",
						letterSpacing: "inherit",
					},
					...sxFormControlLabel,
				}}
				control={
					<Checkbox
						{...props}
						sx={{
							color: colorPrimary,
							paddingBlock: 0,
							"& .MuiSvgIcon-root": { fontSize: 20 },
							"&.Mui-checked": {
								color: colorSecondary,
							},
							"&.Mui-disabled": {
								color: "inherit",
								opacity: 0.7,
							},
							...props.sx,
						}}
					/>
				}
				label={translate(label)}
			/>
		</Hint>
	);
};

export default CustomCheckbox;
